// @ts-nocheck
import { Toast } from "antd-mobile";
import { Image, message, Select, Upload } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./index.css";
import { imageConfig } from "../../../../config/config";
import { useTranslation } from "react-i18next";
import { getText } from "../../../../utils/util";

export default function Info({ userInfo, sendCardsc }) {
  const navigate = useNavigate();
  const [cardsc, setCardsc] = useState("");
  const [rztype, setRztype] = useState(1);
  const { t: translate } = useTranslation();
  const [fileNowName, setfileNowName] = useState("");

  //点击
  const preview = (name) => {
    setfileNowName(name);
  };
  //上传
  const handleChange = (info) => {
    if (info.file.status === "done") {
      if (info.file.response && info.file.response.ok) {
        Toast.show({
          content: `${info.file.name} ${translate(getText("上傳成功"))}`,
        });
        const data = info.file.response;
        if (fileNowName === "cardsc") {
          setCardsc(data.data);
        }
      } else {
        Toast.show({ content: translate(getText(`上传失败`)) });
      }
    } else if (info.file.status === "error") {
      Toast.show({ content: translate(getText(`上传失败`)) });
    }
  };
  const reloadData = () => {
    setCardsc("");
    setRztype(1);
  };
  useEffect(() => {
    setCardsc(userInfo?.cardsc);
  }, [userInfo]);
  return (
    <div className="p-5">
      <div className="mb-6">
        <h3 className="text-base font-medium text-primary-light mb-4">
          {translate(getText("證件手持照片"))}
        </h3>
        <div className="grid grid-cols-1 gap-4 justify-items-center ">
          <Upload
            name="file"
            accept="image/*"
            showUploadList={false}
            action={imageConfig.uploadUrl}
            onChange={handleChange}
          >
            <div 
              onClick={() => preview("cardsc")}
              className={`relative flex flex-col items-center justify-center border-2 border-dashed rounded-lg py-6 transition-all duration-300 ${cardsc ? 'border-primary' : 'border-neutral-600 hover:border-primary-light'}`}
            >
              {cardsc ? (
                <div className="w-full flex justify-center">
                  <img 
                    src={imageConfig.baseImageUrl + cardsc} 
                    className="max-w-full max-h-48 rounded object-contain" 
                    alt="证件照片"
                  />
                </div>
              ) : (
                <>
                  <div className="w-16 h-16 mb-2 rounded-full bg-neutral-700 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary-light" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                  </div>
                  {/* <p className="text-neutral-400">
                    {translate(getText("點擊上傳證件手持照片"))}
                  </p> */}
                </>
              )}
            </div>
          </Upload>
        </div>
      </div>

      <div className="mt-8 flex justify-center">
        <button
          className={`px-8 py-3 rounded-full font-medium transition-all duration-300 
            ${cardsc 
              ? 'bg-gradient-primary text-white shadow-lg transform hover:scale-105' 
              : 'bg-neutral-700 text-neutral-400 cursor-not-allowed'}`}
          onClick={() => {
            if (!cardsc) {
              return;
            }
            sendCardsc({
              ...userInfo,
              cardsc,
            });
            reloadData();
          }}
        >
          {translate(getText("提交"))}
        </button>
      </div>
      
      {/* <div className="mt-4 text-center text-xs text-neutral-500">
        {translate(getText("請確保照片清晰可見"))}
      </div> */}
    </div>
  );
}
